import styled from "styled-components";
import * as Rebass from "@rebass/forms/styled-components";

export const Textarea = styled(Rebass.Textarea)`
  &:disabled {
    background-color: WhiteSmoke;
    color: gray;
  }
`;
